import React, { useEffect, useState } from 'react';
import { Parser } from 'html-to-react';
import { Row, CheckBox, CheckValidInputs, LabelError, ButtonEmptyColor, MainCond, StepBody, StepFooter, ToggleGroupBox, useInput, Line, LineShrink, Between, Label, ButtonIcon } from 'meitav-uikit';
import { UmbracoStep, UmbracoStepChildren } from 'components/Umbraco/UmbracoContext';
import utils from 'utils';
import { popupWin } from 'components/PopUps';
import { postData, setDataLayer } from '../../../../../utils/Functions';
import "./step41.scss";
import Footer from 'components/Footer';

const { UmbracoUtills } = utils;

export default function Step41({
  resource,
  model,
  setModel,
  setStep,
  step,
  resourceError,
  disable,
  nextText
}) {
  const p = new Parser();
  const resourceStep = UmbracoStep(resource, `ThirdSub1Step`);

  const myCond = {
    empty: {
      msg: UmbracoUtills.getValueByKey(resourceError, "chooseRequired"),
      cond: (value) => value === "",
    },
    emptyArr: {
      msg: UmbracoUtills.getValueByKey(resourceError, "benefittorPartnerError"),
      cond: (value) => value.length === 0,
    },
  };

  const statment = useInput("", model.benefittor?.benefittorStatmentId == 2 ? "2" : "1" || "", [myCond.empty]);
  const isConfirm = useInput(p.parse(UmbracoUtills.getValueByKey(resourceStep, 'promisesToUpdateBenifitto')), model.benefittor?.promisesToUpdateBenifittor || null, [MainCond.must]);
  const benefittorList = useInput([], model.benefittor?.benefittors, [myCond.emptyArr]);
  const statmentOpt = [{ text: p.parse(UmbracoUtills.getValueByKey(resourceStep, 'noExistEnjoy')), value: "1" }, { text: p.parse(UmbracoUtills.getValueByKey(resourceStep, 'existEnjoy')), value: "2" }];

  const [disableStatmentId, setDisableStatmentId] = useState("");
  const [mustHaveBenefittorPartner, setMustHaveBenefittorPartner] = useState(false);

  const [popupObj, setPopupObj] = useState("");
  const [popupBnfObj, setPopupBnfObj] = useState("");

  useEffect(() => {

    let bnfObj = {};
    bnfObj.type = "beneficiary";
    bnfObj.specialTitle = UmbracoUtills.getValueByKey(resourceStep, 'addBenefittor');
    bnfObj.resource = resource;
    bnfObj.saveBenefittorModel = saveBenefittorModel;
    bnfObj.className = "beneficiary";
    setPopupBnfObj(bnfObj);
  }, []);

  useEffect(() => {
 
    setMustHaveBenefittorPartner(false);
    setDataLayer("PM - declarations", window.location.pathname, "מסמכים והצהרות", statment.value === 2 ? "בחירה במסך הצהרת נהנה יש נהנה בחשבון" : "בחירה במסך הצהרת נהנה אני פועל לבד")

    if ((model.benefittor?.benefittors == null || model.benefittor?.benefittors?.length == 0)
      && ( ((model.mainUser?.maritalStatus == "2" || model.mainUser?.maritalStatus == "5") 
       && ((!model.mainUser?.asInvestPartner && model.mainUser?.commonBankAccount)|| !model.mainUser?.commonBankAccount)))

    ) {
      setMustHaveBenefittorPartner(true);
      setDisableStatmentId("1");
      statment.setValue("2");

      if (!disable) {
        let obj = {};
        obj.type = "message";
        obj.className = 'popUpInvestPartner'
      //  obj.iconSrc = `${import.meta.env.VITE_REACT_APP_IMAGE_URL || window.location.origin}/${UmbracoUtills.getValueByKey(resourceStep, 'icon')}`;
        obj.title = p.parse(UmbracoUtills.getValueByKey(resourceStep, 'popUpInvestPartner'));
        obj.handleCick = markHasShow;
        popupWin(obj);
      }
    }
    else if ( (model.mainUser?.maritalStatus == "2" || model.mainUser?.maritalStatus == "5") && 
    ((!model.mainUser?.asInvestPartner && model.mainUser?.commonBankAccount)|| !model.mainUser?.commonBankAccount))
    {
   setDisableStatmentId("1");
   }
    if (statment.value == "2") {
      setMustHaveBenefittorPartner(true);
      benefittorList.setConds([myCond.emptyArr]);
    }
    else
      benefittorList.setConds([]);
  }, [statment.value]);



  const markHasShow = () => {
    let tmpModel = model;
    tmpModel.isShowPopupBenefittor = true;
    setModel(tmpModel);
  };

  const addBenefittor = () => {
    let bnfObj = popupBnfObj;
    bnfObj.benefittorIndex = null;
    bnfObj.benefittorModel = { firstName: "", lastName: "", taz: "", birthDate: "", gender: "", relation: "" };
    bnfObj.bnfList = [...benefittorList.value];
    bnfObj.existIdList = getIdList(null);
    popupWin(bnfObj);
  };

  const getIdList = (index) => {
    let tmpList = [];
    tmpList.push(model.mainUser.iDNumber);

    if (model.mainUser.asInvestPartner) {
      tmpList.push(model.bankPartner.taz);
    }

    for (let i = 0; i < benefittorList.value.length; i++) {
      if (i !== index) {
        tmpList.push(benefittorList.value[i].taz);
      }
    }
    return tmpList;
  }

  const editBenefittor = (index) => {
    let bnfObj = popupBnfObj;
    bnfObj.benefittorIndex = index;
    bnfObj.benefittorModel = { ...benefittorList.value[index] };
    bnfObj.bnfList = [...benefittorList.value];
    bnfObj.existIdList = getIdList(index);
    popupWin(bnfObj);
  };

  const delBenefittor = (index) => {
    let tmpList = [...benefittorList.value];
    tmpList.splice(index, 1);
    benefittorList.setValue(tmpList);
  };

  const saveBenefittorModel = (bnfModel, editIndex, bnfList) => {
    let tmpList = bnfList;
    if (editIndex || editIndex == 0) {
      tmpList[editIndex] = bnfModel;
    } else {
      tmpList.push(bnfModel);
    }
    benefittorList.setValue(tmpList);
    window.popupClose();
  };

  const handleNext = async () => {
    if (disable) {
      setStep(42);

      return;
    }
    if (!CheckValidInputs([statment, isConfirm, benefittorList])) {
      return;
    }
    setDataLayer("PM - declarations", window.location.pathname, "מסמכים והצהרות", "המשך מוצלח של הצהרת נהנה");
    let tmpModel = model;
    tmpModel.benefittor.benefittorStatmentId = statment.value;
    tmpModel.benefittor.benefittors = statment.value == "2" ? benefittorList.value : [];
    tmpModel.benefittor.promisesToUpdateBenifittor = isConfirm.value;
    tmpModel.currentStepID = 41;
    tmpModel.stepID = 42;
    postData(tmpModel, setStep);
  };

  const handlePrev = async () => {
    setDataLayer("PM - Levels", "/JoinPersonalDetails", "חזור לשלב הקודם", "חזרה - " + step);

    let tmpModel = model;
    tmpModel.benefittor.benefittorStatmentId = statment.value;
    tmpModel.benefittor.benefittors = statment.value == "2" ? benefittorList.value : [];
    tmpModel.benefittor.promisesToUpdateBenifittor = isConfirm.value;
    setModel(tmpModel);
    if (tmpModel.paymentDetails.depositTypeId == "2") {
      setStep(33);
    } else {
      setStep(34);
    }
  };

  return (
    <>
      <StepBody>
        <Row className="step41">
          <ToggleGroupBox id="statment" disable={disable}{...statment} options={statmentOpt} disableValue={disableStatmentId}
          />
          {mustHaveBenefittorPartner &&
            <Row type='small'>
              {benefittorList.value.length > 0 && benefittorList.value.map((item, i) => (
                <div key={item.taz} >
                  <LineShrink className="bnfLine">
                    <Between className="bnfDiv">
                      <Label>{`${item.firstName} ${item.lastName}`}</Label>
                      <Line className="bnfBtn">
                        <ButtonIcon disable={disable} icon='trashWhite' onClick={() => delBenefittor(i)} />
                        <ButtonIcon disable={disable} icon='editWhite' onClick={() => editBenefittor(i)} />
                      </Line>
                    </Between>
                    <Label >{'נהנה'}</Label>
                  </LineShrink>
                </div>
              ))}
              {!disable && benefittorList.value.length < 3 &&
                <ButtonEmptyColor className="addBenefittor" icon="plus" onClick={addBenefittor} text={UmbracoUtills.getValueByKey(resourceStep, "addBenefittor")} />
              }
              <LabelError text={benefittorList.errorText} />
            </Row>
          }
          <CheckBox {...isConfirm} disable={disable} />
        </Row>
      </StepBody>
      <StepFooter nextText={nextText}
        handleNext={handleNext} handlePrev={handlePrev} />
      <Footer text={p.parse(UmbracoUtills.getValueByKey(
        resourceStep,
        "mainText"
      ))}></Footer>
    </>
  );
}
